export const ORGANIC = 'organic'
export const SPONSORED = 'sponsored'
export const HEADLINE = 'headline'
export const VIDEO = 'video'
